import React, { useEffect, useRef, memo } from 'react';

interface BlockerDetectorProps {
  setBlockerDetector?: (value: boolean) => void;
}

const BlockerDetectorComponent: React.FC<BlockerDetectorProps> = ({
  setBlockerDetector
}) => {
  const detectorElement = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (detectorElement.current?.clientHeight === 0) {
      setBlockerDetector?.(true);
    }
  }, []);

  return (
    <div
      id="banner_ad"
      className="banner_ad"
      ref={detectorElement}
      style={{ height: '1px', position: 'fixed', bottom: 0 }}
    />
  );
};

export const BlockerDetector = memo(BlockerDetectorComponent);
